var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHomeRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 147,
    viewBox: "0 0 176 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 74.76,
    width: 115.752,
    height: 15.7455,
    transform: "rotate(-40.2305 0 74.76)",
    fill: "#808BA4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164.754,
    y: 88.5321,
    width: 115.752,
    height: 15.7455,
    transform: "rotate(-138.713 164.754 88.5321)",
    fill: "#808BA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.2773 32.3235L152.796 87.0735H23.7585L88.2773 32.3235Z",
    fill: "#808BA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153 86H24V140C24 143.866 27.134 147 31 147H72V101H103V147H146C149.866 147 153 143.866 153 140V86Z",
    fill: "#808BA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.777 3.32349H150.777V59.8235L123.777 51.3235V3.32349Z",
    fill: "#808BA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeRestart);
export default __webpack_public_path__ + "static/media/icon-home-restart.795801e9f6747ce8e51fb166f6707dbd.svg";
export { ForwardRef as ReactComponent };